module.exports = __webpack_public_path__ + "img/grgwjkxt.70b49a4e.jpg";